module.exports = __webpack_public_path__ + "static/img/f89b788759beb01abe2909b510867804.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_pro4.png
// module id = NVH6
// module chunks = 1